import React, { FC, Fragment } from 'react';
import { find, map, filter, uniqBy } from 'lodash';
import {
  ModuleRowStyled,
  ExpandCollapseIconStyled,
  PermissionRowStyled,
  StickyColumnStyled,
  PermissionStyled,
  RolePermissionStyled,
  ModuleStyled,
  PerissionGroupStyled,
} from './styled';
import { columnWidth } from '../styled';
import { MatrixItemProps } from './types';
import { Box, theme } from '@bechtel/gds';
import PermissionMenu from '../../menu';
import { multiplePermissionScope, nonePermissionScope } from '../../form-data';
import { MultipleScopeIcon } from '../../multiple-scope-icon';

export const MatrixItem: FC<MatrixItemProps> = ({
  moduleItem,
  selectedRoles,
  moduleIndex,
  rolePermissionScopeList,
  onScopeSelect,
  collapseModules,
  onExpandCollapseModule,
}) => {
  const collapseModule = find(collapseModules, (item) => {
    return item.moduleId === moduleItem.id;
  });
  const collapseMe = collapseModule?.collapsed ? collapseModule?.collapsed : false;
  return (
    <Fragment>
      <ModuleRowStyled key={moduleItem.id}>
        {/* background color added to avoid content overlapping while scrolling horizontally, should be same as of scrollable content */}
        <StickyColumnStyled style={{ backgroundColor: `${theme.colors.grey[100]}` }}>
          <ModuleStyled onClick={() => onExpandCollapseModule(moduleItem.id)}>
            <ExpandCollapseIconStyled icon={collapseMe ? 'plus-circle' : 'minus-circle'} />
            {moduleItem.name}
          </ModuleStyled>
        </StickyColumnStyled>
        <td style={{ verticalAlign: 'middle' }}>
          <RolePermissionStyled>
            {map(selectedRoles, (roleItem) => {
              const filteredPermissions = filter(rolePermissionScopeList, (item) => {
                return (
                  item.roleId === roleItem.id &&
                  item.moduleId === moduleItem.id &&
                  item.scope.id !== nonePermissionScope.id
                );
              });
              const uniquePermissions = uniqBy(filteredPermissions, (item) => {
                return item.scope.id;
              });
              const selectedScope =
                uniquePermissions.length === 1
                  ? uniquePermissions[0].scope
                  : uniquePermissions.length > 1
                  ? multiplePermissionScope
                  : nonePermissionScope;
              return (
                <Box
                  justifyContent={{ sm: 'center' }}
                  style={{ width: columnWidth }}
                  key={`${moduleItem.id}-${roleItem.id}`}
                  ml={{ sm: '500' }}
                >
                  <PerissionGroupStyled selectedScope={selectedScope}>
                    {selectedScope.id === multiplePermissionScope.id && (
                      <Box mr={{ sm: '400' }}>
                        <MultipleScopeIcon />
                      </Box>
                    )}
                    {selectedScope.name}
                  </PerissionGroupStyled>
                </Box>
              );
            })}
          </RolePermissionStyled>
        </td>
      </ModuleRowStyled>
      <tr style={collapseMe ? { visibility: 'collapse' } : { visibility: 'visible' }}>
        <td colSpan={2}>
          <table style={{ width: '100%' }}>
            <tbody>
              {map(moduleItem.permissions, (permissionItem, permissionIndex) => {
                return (
                  <PermissionRowStyled key={permissionItem.id}>
                    {/* background color added to avoid content overlapping while scrolling horizontally, should be same as of scrollable content */}
                    <StickyColumnStyled style={{ backgroundColor: `${theme.colors.white}` }}>
                      <PermissionStyled>{permissionItem.name}</PermissionStyled>
                    </StickyColumnStyled>
                    <td style={{ verticalAlign: 'middle' }}>
                      <RolePermissionStyled>
                        {map(selectedRoles, (roleItem) => {
                          const selectedItem = find(rolePermissionScopeList, (item) => {
                            return (
                              item.roleId === roleItem.id &&
                              item.moduleId === moduleItem.id &&
                              item.permissionId === permissionItem.id
                            );
                          });
                          return (
                            <Box
                              key={`${moduleItem.id}-${permissionItem.id}-${roleItem.id}`}
                              justifyContent={{ sm: 'center' }}
                              style={{ width: columnWidth }}
                              ml={{ sm: '500' }}
                            >
                              <PermissionMenu
                                applicableScopes={[nonePermissionScope, ...permissionItem.applicableScopes]}
                                selectedScope={selectedItem?.scope ? selectedItem?.scope : nonePermissionScope}
                                tabIndex={(moduleIndex + 1) * (permissionIndex + 1)}
                                onScopeSelect={(selectedScope) => {
                                  onScopeSelect(roleItem.id, selectedItem?.id, selectedScope);
                                }}
                              />
                            </Box>
                          );
                        })}
                      </RolePermissionStyled>
                    </td>
                  </PermissionRowStyled>
                );
              })}
            </tbody>
          </table>
        </td>
      </tr>
    </Fragment>
  );
};

export default MatrixItem;
